import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DIALOG_HIDE_CLASS } from '../../../shared/constants';
import { ILotEdit, IRanchLotModalData } from './interfaces';
import { LotSubscriptionService } from '../../../../services/subscriptions/lot.subscription';
import { RanchLotFormComponent } from '../../shared/ranch-lot-form/ranch-lot-form';
import { RanchService } from '../../service';
import { SharedUpdateService } from '../../../shared/dialogs/update.service';
import { UpdateService } from '../../../../services/update.service';

@Component({
	moduleId: module.id,
	selector: 'ranch-lot-modal',
	templateUrl: 'main.html',
	styleUrls: [ 'main.scss']
})

export class RanchLotModalComponent implements OnDestroy {
	public isSaving: boolean;

	@ViewChild(RanchLotFormComponent, { static: false })
	public lotForm: RanchLotFormComponent;

	private _subscriptions$: Subject<boolean>;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IRanchLotModalData,
		private _dialogRef: MatDialogRef<RanchLotModalComponent>,
		private _lotSubscriptionService: LotSubscriptionService,
		private _ranchService: RanchService,
		private _sharedUpdateService: SharedUpdateService,
		private _updateService: UpdateService
	) {
		this.isSaving = false;
		this._subscriptions$ = new Subject();

		this._dialogRef.backdropClick()
			.pipe(takeUntil(this._subscriptions$)).subscribe((e: MouseEvent) => {
				this.close();
			});
	}

	ngOnDestroy(): void {
		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public close(): void {
		if (!this.lotForm) {
			this._closeFinal();
			return;
		}

		this.lotForm.cancel();
	}

	public delete(): void {
		this._ranchService.deleteRanchLot(this.data.Id)
		.then(() => {
			this._updateAndClose(this.data.Id, null);
			this._sharedUpdateService.deleteComplete();
		});
	}

	public hide(): void {
		this._dialogRef.addPanelClass(DIALOG_HIDE_CLASS);
	}

	public show(): void {
		this._dialogRef.removePanelClass(DIALOG_HIDE_CLASS);
	}

	public submit(lot: ILotEdit): void {
		if (this.isSaving) {
			return;
		}

		this.isSaving = true;

		(this.data && this.data.Id ?
			this._ranchService.editRanchLot(lot) :
			this._ranchService.addRanchLot(lot))
			.then(() => {
				this.isSaving = false;
				this._updateAndClose(this.data ? this.data.Id : null, lot);
			});
	}

	private _closeFinal(): void {
		this._dialogRef.close();
	}

	private _updateAndClose(lotId: number, lot: ILotEdit): void {
		this._updateService.setRanchSettingsUpdated('lots');
		this._lotSubscriptionService.setCurrentRanchLots(this._updateService.currentRanchId, lotId, lot);
		this._closeFinal();
	}
}
